import { locale } from 'svelte-i18n'

const STORAGE_KEY = 'defaultLanguage'
const FALLBACK_LOCALE = 'de'

export const LanguageService = {
	getSavedLanguage(): string {
		if (typeof window === 'undefined') {
			return FALLBACK_LOCALE
		}

		return localStorage.getItem(STORAGE_KEY) || FALLBACK_LOCALE
	},

	setLanguage(lang: string) {
		if (typeof window === 'undefined') return

		localStorage.setItem(STORAGE_KEY, lang)
		locale.set(lang)
	}
}

export const LANGUAGE_OPTIONS = [
	{
		id: 'de',
		title: 'German (Deutsch)'
	},
	{
		id: 'en',
		title: 'English'
	}
]
